import { SEND_FILE, SEND_FILE_SUCCESS } from './constants';

/**
 *
 * @param form
 * @param resolve
 * @returns {{form: *, resolve: *, type: string}}
 */
const sendFile = (form, resolve) => ({
    type: SEND_FILE,
    form,
    resolve
});

/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const sendFileSuccess = (result) => ({
    type: SEND_FILE_SUCCESS,
    result
});

export { sendFile, sendFileSuccess };